import { memo, useCallback, useEffect, useState } from "react";

// UI
import VehicleStatusBadge from "./components/VehicleStatusBadge";
import VehicleStatusFlow from "./components/VehicleStatusFlow/VehicleStatusFlow";

// Servisni sloj
import { FleetVehicleStatusEnum } from "services/api/fleet/vehicles/types";

import { VehicleStatusEditCardProps } from "./types";

/**
 * Značka statusa. Klik otvara `VehicleStatusFlow` — odabir statusa i podaci koje traži
 * su u istom čarobnjaku, pa se isti tok koristi i izvan značke (nakon unosa štete).
 */
const VehicleStatusEditCard: React.FC<VehicleStatusEditCardProps> = ({
  vehicleId,
  currentStatus,
  onStatusChange,
}) => {
  const [status, setStatus] = useState<FleetVehicleStatusEnum>(currentStatus);
  const [showFlow, setShowFlow] = useState<boolean>(false);

  // Status se mijenja i izvan značke (premještaj vozila), pa se prati dohvaćeno vozilo.
  useEffect(() => {
    setStatus(currentStatus);
  }, [currentStatus]);

  const handleBadgeClick = useCallback(() => {
    setShowFlow(true);
  }, []);

  const handleFlowClose = useCallback(() => {
    setShowFlow(false);
  }, []);

  const handleFlowSaved = useCallback(
    (newStatus: FleetVehicleStatusEnum) => {
      setStatus(newStatus);
      onStatusChange?.(newStatus);
    },
    [onStatusChange]
  );

  return (
    <>
      <VehicleStatusBadge status={status} onClick={handleBadgeClick} />

      {vehicleId && (
        <VehicleStatusFlow
          show={showFlow}
          vehicleId={vehicleId}
          currentStatus={status}
          onClose={handleFlowClose}
          onSaved={handleFlowSaved}
        />
      )}
    </>
  );
};

export default memo(VehicleStatusEditCard);
